import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
@Component({
  selector: 'cipx-drawer-header',
  templateUrl: './drawer-header.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatIcon,
    MatIconButton,
    MatDivider,
  ]
})
export class DrawerHeaderComponent {
  @Input() title = '';
  @Input() showCloseButton = false;
  @Output() closeEvent = new EventEmitter<void>();
  @Output() backEvent = new EventEmitter<void>();
  @Input() showBackButton = false;
}
